module.exports = __webpack_public_path__ + "static/faceit-logo-white@3x-01b66f8bb6c5d4fb509c43888aefe11f.png";